module.exports = __webpack_public_path__ + "img/record-mockup.4854001f.png";